
<div
	class="tile-container"
	:disabled="disabled"
	:selected="selected"
	:type="type"
	@click="handleClick($event)"
>
	<div v-if="$slots['action']" class="tile-action">
		<slot name="action" />
	</div>
	<div class="tile-content">
		<slot />

		<h5 v-if="title" class="tile-title">
			{{ title }}
		</h5>
		<p v-if="description" class="tile-description paragraph-2">
			{{ description }}
		</p>
	</div>
	<div v-if="$slots['footer']" class="tile-footer" :type="footerType">
		<slot name="footer" />
	</div>
</div>
